module.exports = __webpack_public_path__ + "static/media/seguro.5411bbf3.png";